import { defineMessages } from 'react-intl'

export default defineMessages({
  genericErrorTitle: {
    id: 'submitExpenseReportPresenter.genericErrorTitle',
    defaultMessage: 'Error',
  },
  genericError: {
    id: 'submitExpenseReportPresenter.genericError',
    defaultMessage:
      'There was an error submitting your expense report. Please try again.',
  },
  budgetExceededErrorTitle: {
    id: 'submitExpenseReportPresenter.budgetExceededErrorTitle',
    defaultMessage: 'Budget exceeded',
  },
  budgetExceededError: {
    id: 'submitExpenseReportPresenter.budgetExceededError',
    defaultMessage:
      'This expense report exceeds the available budget and cannot be submitted.',
  },
})
